import { getFilesForDeal } from 'api';
import { CACHE_TIME, STALE_TIME, errorHandler } from 'helpers';
import { generateFilesQueryKey } from 'helpers/queryKeys';

export const filesQuery = (dealId: string, fileType: string) => ({
  queryKey: generateFilesQueryKey(dealId, fileType),
  queryFn: () => getFilesForDeal(dealId, fileType),
  cacheTime: CACHE_TIME,
  staleTime: STALE_TIME,
  onError: (error: unknown) => errorHandler(error),
});
